// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2CPzz","left":"InfoRow_left__3q7kc"};